import AuthorizedContent from "./AuthorizedContent";

export default AuthorizedContent